<template>
  <div class="live-container" :style="containerStyle">
    <!-- 顶部公告 -->
    <van-notice-bar
      left-icon="volume-o"
      :text="baseData.tip_content || '通知公告：直播开始时间为晚上 10 点至凌晨 4 点，精彩不容错过！'"
      color="#ffffff"
      background="#f57162"
      class="custom-notice"
    />

    <!-- 视频播放层：原生 video，不使用 xgplayer -->
    <div class="video-layer" v-show="showPlayer">
      <video
        ref="videoPlayer"
        id="player"
        class="native-video"
        preload="auto"
        playsinline="true"
        webkit-playsinline="true"
        x5-playsinline="true"
        x-webkit-airplay="deny"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="false"
        x5-video-orientation="portrait"
        x5-video-ignore-metadata="true"
        controlsList="nodownload noplaybackrate nofullscreen"
        disablePictureInPicture
        @ended="handleVideoEnded"
        @timeupdate="handleNativeTimeUpdate"
        @play="handleNativePlay"
        @pause="handleNativePause"
        @error="handleNativeError"
      ></video>
    </div>

    <!-- 底部操作栏 -->
    <div class="bottom-controls">
      <div class="control-row">
        <div class="btn-item btn-large btn-gradient" @click="handlePlay">
          <div class="icon-wrap play-icon">
            <van-icon :name="isPlaying ? 'pause' : 'play'" />
          </div>
          <span class="btn-text-large">{{ isPlaying ? '暂停播放' : '开始播放' }}</span>
        </div>

        <div class="btn-item btn-small btn-white-trans" @click="playLiveStream">
          <van-icon name="video-o" class="icon-red" />
          <span class="btn-text-red">直播</span>
        </div>

        <div class="btn-item btn-small btn-white-trans" @click="playVodStream">
          <van-icon name="play-circle-o" class="icon-pink" />
          <span class="btn-text-pink">视频</span>
        </div>
      </div>

      <div class="control-row">
        <div class="btn-item btn-small btn-dark-trans" @click="toggleContinuous">
          <van-icon name="replay" :class="isContinuous ? 'icon-yellow' : 'icon-white'" />
          <div class="btn-text-stack">
            <span :style="{ color: isContinuous ? '#f1c40f' : '#fff' }">连续</span>
            <span :style="{ color: isContinuous ? '#f1c40f' : '#fff' }">播放</span>
          </div>
        </div>

        <div class="btn-item btn-small btn-dark-trans" @click="playNextVideo">
          <van-icon name="play-circle" class="icon-white" />
          <div class="btn-text-stack">
            <span :style="{ color: isContinuous ? '#f1c40f' : '#fff' }">下个</span>
            <span :style="{ color: isContinuous ? '#f1c40f' : '#fff' }">视频</span>
          </div>
        </div>

        <div class="btn-item btn-small btn-yellow" @click="goHome">
          <van-icon name="star" class="icon-white" />
          <span class="btn-text-white">精选</span>
        </div>

        <div class="btn-item btn-small btn-orange" @click="goHome">
          <van-icon name="gem" class="icon-white" />
          <span class="btn-text-white">精品</span>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <van-dialog
      class="demo-dialog van-dialog detail-box"
      v-model="payBoxModal"
      :before-close="closeDig"
      :showConfirmButton="false"
      :showCancelButton="false"
      :closeOnClickOverlay="true"
    >
      <div class="pay-title" style="color:#fff;text-align: center;font-size: 16px;padding: 15px 0;">
        付费即可观看完整视频
      </div>

      <div class="pay-btn-box">
        <van-button
          round
          v-for="(item, index) in payBtnList"
          :key="index"
          class="index-pay-item"
          :color="item.color || '#4caf50'"
          :style="{
            background: (item.color || '#4caf50') + ' !important',
            color: '#fff !important',
            border: 'none',
            margin: '5px auto',
            width: '80%',
            display: 'block'
          }"
          @click="linkTo(item)"
        >
          <div style="display: flex;flex-direction: column;align-items: center;">
            <span style="color:#fff;">{{ item.name }}</span>
          </div>
        </van-button>
      </div>

      <div class="pay-code-section">
        <div class="pay-code-tip">请及时保存口令，方便找回已购</div>
        <div class="pay-code-box">
          <div class="pay-code-text">{{ shareDataInfo.shareAgentCode }}</div>
          <div class="pay-code-copy" @click="handelClickCopy(shareDataInfo.shareAgentCode)">复制</div>
        </div>
      </div>

      <div class="pay-action-btns">
        <div class="pay-action-btn close-btn" @click="closeDigNew">关闭</div>
      </div>
    </van-dialog>

    <!-- 支付弹窗 -->
    <van-action-sheet v-model="payModal" title="支付通道">
      <div class="pay-card">
        <div
          class="pay-list"
          style="display:flex;align-items: center;flex-direction:row;justify-content: space-around;"
        >
          <div
            class="pay-item"
            v-for="(item, index) in payList"
            :key="index"
            @click="goPayOrder(item.id)"
            style="display: flex;flex-direction: column;align-items: center;"
          >
            <img
              class="picon"
              style="width: 150px;height: 56px;"
              src="../assets/alipay.png"
              v-if="item.pay_channel == 'alipay'"
            />

            <img
              class="picon"
              style="width: 150px;height: 56px;"
              src="../assets/wechat.png"
              v-if="item.pay_channel == 'wxpay'"
            />

            <div class="pay-name" style="display: flex;flex-direction: column;align-items: center;width: 100%;">
              <span v-if="item.pay_channel == 'alipay'" class="txt">推荐使用</span>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>

    <!-- 分享提示弹窗 -->
    <van-dialog
      v-model="showShareModal"
      title="温馨提示"
      show-cancel-button
      confirm-button-text="复制链接"
      cancel-button-text="我已分享"
      @confirm="handleGoShare"
      @cancel="handleShareDone"
    >
      <div style="padding: 20px; text-align: center; color: #666; font-size: 15px;">
        免费观看3个短视频已用完，分享给好友即可再获得10次免费观看机会！
      </div>

      <div style="text-align: center; margin-bottom: 15px;">
        <div style="color: #f53036; font-size: 18px; font-weight: bold; margin-bottom: 5px;">
          分享链接
        </div>

        <div
          style="background: #f5f5f5; padding: 10px; border-radius: 4px; word-break: break-all; margin: 0 15px; font-size: 13px;"
        >
          {{ shareUrl }}
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { initData, getVideo, pvv6Api, pav7Api } from "@/api/api";

export default {
  name: "LiveIndex",

  data() {
    return {
      baseData: {},

      isPlaying: false,
      showPlayer: false,
      isContinuous: false,

      currentVideoUrl: "",
      playType: "video",
      currentVideoId: null,

      /**
       * 修复 AbortError 的关键状态
       * isChangingVideo：正在切换视频，避免 timeupdate/click 重复触发 pause/play
       * isAutoPlaying：正在执行 play()，避免 play() 未完成又被 pause()
       * lastPlayUrl：记录上一次播放地址，避免重复 load()
       */
      isChangingVideo: false,
      isAutoPlaying: false,
      lastPlayUrl: "",

      /**
       * 保留字段，避免你其他地方如果有引用不会报错。
       * 现在不再使用 xgplayer。
       */
      try_pay_player: null,

      payBoxModal: false,
      payModal: false,
      payBtnList: [],
      payList: [],
      goodsInfo: null,

      shareDataInfo: {
        shareAgentCode: ""
      },

      params: {
        ldk: "",
        uid: ""
      },

      showShareModal: false,
      is_jump: 0
    };
  },

  computed: {
    containerStyle() {
      const bgImg = this.baseData.live_thumb_image
        ? this.baseData.live_thumb_image
        : "https://img1.baidu.com/it/u=3007963384,1832049015&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=889";

      return {
        backgroundImage: `url(${bgImg})`
      };
    },

    shareUrl() {
      return this.baseData.shareUrl || "";
    }
  },

  created() {
    this.params.ldk = this.$route.query.ldk || window.localStorage.getItem("ldk") || "";
    this.params.uid = this.$route.query.uid || window.localStorage.getItem("visitorId") || "";
    this.shareDataInfo.shareAgentCode = window.localStorage.getItem("shareAgentCode") || "";

    const payListStr = window.localStorage.getItem("payList");

    if (payListStr) {
      try {
        this.payList = JSON.parse(payListStr);
      } catch (e) {}
    }

    this.fetchBaseData();
  },

  beforeDestroy() {
    this.destroyPlayer(true);
  },

  methods: {
    fetchBaseData() {
      const query = this.$route.query;

      initData(query)
        .then(res => {
          if (res) {
            const temp = JSON.parse(this.$decryptData(res));
            console.log("初始化数据：", temp);

            this.baseData = temp;

            if (temp.live && temp.live.url) {
              this.currentVideoUrl = temp.live.url;
              this.playType = "live";
            } else if (temp.video && temp.video.url) {
              this.currentVideoUrl = temp.video.url;
              this.playType = "video";
            }

            console.log("当前播放地址：", this.currentVideoUrl);
          }
        })
        .catch(err => {
          console.error("获取直播配置失败:", err);
        });
    },

    /**
     * 原 createDetailPlayer 保留方法名，避免其他逻辑不变。
     * 修复点：
     * 1. 不再每次播放前 destroyPlayer()
     * 2. 只在 URL 变化时 video.load()
     * 3. 使用 safePlayVideo() 防止 play() 被 pause/load 打断
     */
    createDetailPlayer(videoInfo) {
      if (!videoInfo || !videoInfo.link) {
        this.$toast("视频地址为空");
        return;
      }

      const newUrl = videoInfo.link;

      console.log("开始创建原生 video 播放器：", newUrl);

      this.isChangingVideo = true;
      this.isAutoPlaying = false;
      this.showPlayer = true;
      this.isPlaying = false;

      this.$nextTick(() => {
        const video = this.$refs.videoPlayer;

        if (!video) {
          console.log("video 容器不存在");
          this.isChangingVideo = false;
          return;
        }

        this.initNativeVideo(video);

        try {
          /**
           * 关键：
           * 只有地址变化时才 pause + src + load。
           * 不要频繁 removeAttribute('src') + load()，
           * 否则会打断正在执行的 play()。
           */
          if (this.lastPlayUrl !== newUrl) {
            try {
              video.pause();
            } catch (e) {}

            video.src = newUrl;
            video.load();

            this.currentVideoUrl = newUrl;
            this.lastPlayUrl = newUrl;
          }

          try {
            video.currentTime = 0;
          } catch (e) {}
        } catch (e) {
          console.log("初始化 video 地址失败：", e);
        }

        setTimeout(() => {
          this.isChangingVideo = false;
          this.safePlayVideo();
        }, 120);
      });
    },

    initNativeVideo(video) {
      if (!video) return;

      /**
       * 关键：不要显示原生 controls。
       * 没有 controls，安卓浏览器控制栏下载按钮就不会出现。
       */
      video.controls = false;
      video.removeAttribute("controls");

      /**
       * 尽量禁止全屏、下载、画中画、倍速。
       * 注意：部分国产浏览器内核可能会强制接管，前端无法 100% 禁止。
       */
      video.setAttribute("playsinline", "true");
      video.setAttribute("webkit-playsinline", "true");
      video.setAttribute("x5-playsinline", "true");
      video.setAttribute("x5-video-player-type", "h5");
      video.setAttribute("x5-video-player-fullscreen", "false");
      video.setAttribute("x5-video-orientation", "portrait");
      video.setAttribute("x5-video-ignore-metadata", "true");
      video.setAttribute("x-webkit-airplay", "deny");

      video.setAttribute("controlsList", "nodownload noplaybackrate nofullscreen");
      video.setAttribute("disablePictureInPicture", "true");

      try {
        video.controlsList = "nodownload noplaybackrate nofullscreen";
        video.disablePictureInPicture = true;
      } catch (e) {}

      /**
       * 禁止右键、长按菜单、双击全屏。
       */
      video.oncontextmenu = function(e) {
        e.preventDefault();
        return false;
      };

      video.ondblclick = function(e) {
        e.preventDefault();
        return false;
      };

      video.addEventListener("contextmenu", function(e) {
        e.preventDefault();
        return false;
      });

      video.addEventListener("dblclick", function(e) {
        e.preventDefault();
        return false;
      });

      video.style.width = "100%";
      video.style.height = "100%";
      video.style.objectFit = "contain";
      video.style.background = "#000";
    },

    /**
     * 安全播放方法：
     * 防止连续 play()、pause()、load() 互相打断。
     */
    safePlayVideo() {
      const video = this.$refs.videoPlayer;

      if (!video) return;

      if (this.isAutoPlaying) {
        return;
      }

      this.initNativeVideo(video);

      this.showPlayer = true;
      this.isAutoPlaying = true;

      let playPromise = null;

      try {
        playPromise = video.play();
      } catch (err) {
        this.isPlaying = false;
        this.isAutoPlaying = false;
        console.log("播放器启动异常：", err);
        this.$toast("请点击开始播放");
        return;
      }

      if (playPromise && typeof playPromise.then === "function") {
        playPromise
          .then(() => {
            this.isPlaying = true;
            this.isAutoPlaying = false;
          })
          .catch(err => {
            this.isPlaying = false;
            this.isAutoPlaying = false;

            console.log("原生 video 自动播放失败：", err);

            /**
             * AbortError 是切换视频过程中常见的打断错误。
             * 这里不再提示播放失败，避免误判。
             */
            if (err && err.name === "AbortError") {
              return;
            }

            this.showPlayer = true;
            this.$toast("请点击开始播放");
          });
      } else {
        this.isPlaying = true;
        this.isAutoPlaying = false;
      }
    },

    /**
     * 保留方法，避免其他地方调用时报错。
     * 现在 video 标签已经去掉 @click，不再通过点击视频画面播放/暂停。
     */
    toggleNativeVideo() {
      return false;
    },

    handleNativePlay() {
      this.isPlaying = true;
      this.showPlayer = true;
    },

    handleNativePause() {
      /**
       * 切换视频过程中触发 pause 是正常现象，不要影响状态。
       */
      if (this.isChangingVideo) {
        return;
      }

      this.isPlaying = false;
    },

    handleNativeError(e) {
      console.log("原生 video 播放错误：", e);
      this.isPlaying = false;
      this.isAutoPlaying = false;
      this.isChangingVideo = false;
      this.showPlayer = true;
      this.$toast("视频加载失败");
    },

    handleNativeTimeUpdate() {
      this.handlePlayerTimeUpdate();
    },

    playBplayer() {
      this.safePlayVideo();
    },

    /**
     * 销毁播放器
     * clearSrc=true：离开页面、返回首页时清空 src
     * clearSrc=false：普通暂停，不清空 src，避免打断播放
     */
    destroyPlayer(clearSrc = true) {
      const video = this.$refs.videoPlayer;

      if (video) {
        try {
          video.pause();

          if (clearSrc) {
            video.removeAttribute("src");
            video.load();
            this.lastPlayUrl = "";
          }
        } catch (e) {
          console.log("销毁 video 失败:", e);
        }
      }

      this.try_pay_player = null;
      this.isPlaying = false;
      this.isAutoPlaying = false;
      this.isChangingVideo = false;
    },

    handlePlay() {
      if (!this.currentVideoUrl) {
        return this.$toast("暂无视频资源可播放");
      }

      console.log("点击开始播放：", this.currentVideoUrl);

      const video = this.$refs.videoPlayer;

      /**
       * 正在切换或自动播放时，防止重复点击造成 AbortError。
       */
      if (this.isChangingVideo || this.isAutoPlaying) {
        return;
      }

      /**
       * 已经显示播放器，直接控制原生 video 播放/暂停。
       */
      if (this.showPlayer && video) {
        this.initNativeVideo(video);

        if (this.isPlaying) {
          video.pause();
          this.isPlaying = false;
          return;
        }

        if (this.playType === "video" && video.currentTime >= 30) {
          if (this.isContinuous) {
            this.playNextVideo();
          } else {
            this.$toast("该视频已看完，请播放下个视频");
          }

          return;
        }

        this.playBplayer();
        return;
      }

      /**
       * 没有显示播放器，创建并播放。
       */
      this.startPlayForce();
    },

    startPlayForce() {
      if (this.playType === "video") {
        if (this.currentVideoId !== (this.baseData.video ? this.baseData.video.id : null)) {
          if (!this.checkPlayLimit(true)) return;

          this.currentVideoId = this.baseData.video ? this.baseData.video.id : null;

          let playData = JSON.parse(localStorage.getItem("livePlayData") || "{}");
          let today = new Date().toLocaleDateString();

          if (playData.date !== today) {
            playData = {
              date: today,
              count: 0
            };
          }

          playData.count++;
          localStorage.setItem("livePlayData", JSON.stringify(playData));
        }
      }

      this.showPlayer = true;
      this.isPlaying = false;

      this.$nextTick(() => {
        this.createDetailPlayer({
          link: this.currentVideoUrl,
          thumb_image: this.baseData.video ? this.baseData.video.thumb_image : ""
        });
      });
    },

    /**
     * 试看 30 秒控制
     * 修复点：
     * currentTime >= 30 后只触发一次，避免重复 pause/playNextVideo。
     */
    handlePlayerTimeUpdate() {
      const video = this.$refs.videoPlayer;

      if (!video) return;
      if (this.playType !== "video") return;
      if (this.isChangingVideo) return;

      const currentTime = video.currentTime || 0;

      if (currentTime >= 30) {
        this.isChangingVideo = true;

        try {
          video.pause();
        } catch (e) {}

        this.isPlaying = false;

        if (this.isContinuous) {
          setTimeout(() => {
            this.playNextVideo();
          }, 150);
        } else {
          setTimeout(() => {
            this.isChangingVideo = false;
          }, 300);

          if (!this.checkPlayLimit(true)) {
            // checkPlayLimit 内部处理提示
          } else {
            this.$toast("该视频已看完，请播放下个视频");
          }
        }
      }
    },

    checkPlayLimit(showPrompt = true) {
      let playData = JSON.parse(localStorage.getItem("livePlayData") || "{}");
      let today = new Date().toLocaleDateString();

      if (playData.date !== today) {
        playData = {
          date: today,
          count: 0
        };
      }

      let allowedCount = 3 + parseInt(this.baseData.times || 0);

      if (playData.count >= allowedCount) {
        if (this.is_jump == 1) {
          this.goHome();
        }

        if (showPrompt) {
          if (parseInt(this.baseData.times || 0) === 0) {
            this.showShareModal = true;
          } else {
            this.is_jump = 1;
            this.$toast("今日免费已看完，请明天再来");
          }
        }

        return false;
      }

      if (playData.count > 0 && playData.count % 3 == 0) {
        this.showShareModal = true;
      }

      return true;
    },

    playLiveStream() {
      if (this.baseData.live && this.baseData.live.url) {
        this.playType = "live";
        this.currentVideoUrl = this.baseData.live.url;
        this.currentVideoId = null;
        this.isChangingVideo = false;
        this.startPlayForce();
        this.$toast("已切换到直播源");
      } else {
        this.$toast("当前不在直播时间段");
      }
    },

    playVodStream() {
      this.playType = "video";

      if (this.baseData.video && this.baseData.video.url) {
        this.currentVideoUrl = this.baseData.video.url;
        this.isChangingVideo = false;
        this.startPlayForce();
        this.$toast("已切换到点播视频");
      } else {
        this.playNextVideo();
      }
    },

    playNextVideo() {
      if (this.isChangingVideo && this.isAutoPlaying) {
        return;
      }

      if (!this.checkPlayLimit(true)) {
        this.isChangingVideo = false;
        return;
      }

      this.isChangingVideo = true;

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true
      });

      getVideo()
        .then(res => {
          this.$toast.clear();

          if (res) {
            const temp = JSON.parse(this.$decryptData(res));
            console.log("获取下个视频：", temp);

            if (temp.video && temp.video.url) {
              this.playType = "video";
              this.currentVideoUrl = temp.video.url;
              this.baseData.video = temp.video;
              this.currentVideoId = null;

              this.isChangingVideo = false;
              this.startPlayForce();
            } else {
              this.isChangingVideo = false;
              this.$toast("未获取到视频");
            }
          } else {
            this.isChangingVideo = false;
            this.$toast("未获取到视频");
          }
        })
        .catch(err => {
          console.log("获取下个视频失败：", err);
          this.isChangingVideo = false;
          this.$toast.clear();
          this.$toast("获取视频失败");
        });
    },

    toggleContinuous() {
      this.isContinuous = !this.isContinuous;
      this.$toast(this.isContinuous ? "已开启连续播放" : "已关闭连续播放");
    },

    handleVideoEnded() {
      if (this.isContinuous && this.playType === "video") {
        this.playNextVideo();
      } else {
        this.isPlaying = false;
      }
    },

    goHome() {
      this.destroyPlayer(true);
      this.showPlayer = false;
      this.$router.push("/");
    },

    goPay() {
      this.$router.push("/pay");
    },

    handleGoShare() {
      if (this.shareUrl) {
        this.handelClickCopy(this.shareUrl);
      } else {
        this.$toast("获取分享链接失败");
      }
    },

    handleShareDone() {
      this.$toast.loading({
        message: "正在刷新状态...",
        forbidClick: true
      });

      const query = this.$route.query;

      initData(query)
        .then(res => {
          this.$toast.clear();

          if (res) {
            const temp = JSON.parse(this.$decryptData(res));

            this.baseData.times = temp.times;
            this.baseData.jump_url = temp.jump_url;

            if (this.checkPlayLimit(false)) {
              this.$toast("刷新成功，您已获得新的观看次数！");
              this.showShareModal = false;
            } else {
              this.$toast("暂未检测到有效分享，请确保好友已打开链接。");
            }
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },

    showPayModal() {
      let vid =
        this.playType === "live"
          ? this.baseData.live
            ? this.baseData.live.id
            : 0
          : this.baseData.video
          ? this.baseData.video.id
          : 0;

      let datas = {
        ldk: this.params.ldk,
        uid: this.params.uid,
        vid: vid
      };

      let localPayBtnList = window.localStorage.getItem("localPayBtnList");

      if (localPayBtnList && localPayBtnList !== "undefined" && localPayBtnList !== null) {
        let temp = JSON.parse(this.$decryptData(localPayBtnList));
        this.payBtnList = temp;
        this.payBoxModal = true;
      } else {
        pvv6Api(datas).then(res => {
          let temp = JSON.parse(this.$decryptData(res));
          this.payBtnList = temp;
          this.payBoxModal = true;
          window.localStorage.setItem("localPayBtnList", res);
        });
      }
    },

    closeDig(action, done) {
      done();
    },

    closeDigNew() {
      this.payBoxModal = false;

      const video = this.$refs.videoPlayer;

      if (video) {
        try {
          video.pause();
        } catch (e) {}
      }

      this.isPlaying = false;
      this.isAutoPlaying = false;
    },

    handelClickCopy(text) {
      this.$copyText(text)
        .then(() => {
          this.$toast("复制成功");
        })
        .catch(() => {
          this.$toast("复制失败");
        });
    },

    linkTo(item) {
      this.goodsInfo = item;
      this.payModal = true;
    },

    goPayOrder(pay_id) {
      let that = this;

      if (!that.goodsInfo) {
        that.$toast("请选择影视资源类型");
        return;
      }

      let ip = window.localStorage.getItem("IP");

      let vid =
        this.playType === "live"
          ? this.baseData.live
            ? this.baseData.live.id
            : 0
          : this.baseData.video
          ? this.baseData.video.id
          : 0;

      let data = {
        pay_id: pay_id,
        ip: ip,
        uid: that.params.uid,
        vid: vid,
        ldk: this.params.ldk,
        is_type: this.goodsInfo.is_type
      };

      pav7Api(data).then(res => {
        let temp = JSON.parse(that.$decryptData(res));

        if (temp.code == 1) {
          if (temp.data.payurl) {
            if (temp.data.is_iframe == 1) {
              this.$router.push({
                path: "/pay",
                query: {
                  payurl: temp.data.payurl
                }
              });
            } else {
              window.location.href = temp.data.payurl;
            }
          }
        } else {
          that.$toast.fail(temp.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.van-icon .van-icon-volume-o .van-notice-bar__left-icon {
  color: #fff !important;
}

.live-container {
  height: 100vh;
  width: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden; */
}

/* 视频层：背景层，不盖住顶部和底部操作栏 */
.video-layer {
  /* position: absolute;
  top: 40px;
  left: 0; */
  width: 100%;
  height: 80%;
  z-index: 1;
  background: #000;
  overflow: hidden;
}

/* 原生 video，无 controls，所以安卓不会出现下载按钮 */
.native-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
  display: block;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  pointer-events: none;
}

/* 尽量隐藏 WebKit 原生控制栏 */
.native-video::-webkit-media-controls {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

.native-video::-webkit-media-controls-enclosure {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

.native-video::-webkit-media-controls-panel {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

.native-video::-webkit-media-controls-play-button {
  display: none !important;
}

.native-video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}

.native-video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}

.native-video::-webkit-media-controls-timeline {
  display: none !important;
}

.native-video::-webkit-media-controls-current-time-display {
  display: none !important;
}

.native-video::-webkit-media-controls-time-remaining-display {
  display: none !important;
}

.native-video::-webkit-media-controls-mute-button {
  display: none !important;
}

.native-video::-webkit-media-controls-volume-slider {
  display: none !important;
}

/* 顶部公告栏必须在视频上方 */
.custom-notice {
  font-size: 14px;
  height: 40px;
  position: relative;
  z-index: 9999 !important;
}

/* 底部操作栏必须在视频上方 */
.bottom-controls {
  position: fixed;
  z-index: 9999 !important;
  padding: 10px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, transparent 100%);
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
}

.control-row {
  display: flex;
  gap: 10px;
  width: 100%;
  position: relative;
  z-index: 10000 !important;
}

.btn-item {
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  transition: opacity 0.2s;
  position: relative;
  z-index: 10000 !important;
}

.btn-item:active {
  opacity: 0.8;
}

.btn-large {
  flex: 2;
  height: 60px;
  padding-left: 15px;
  justify-content: flex-start;
  gap: 15px;
}

.btn-small {
  flex: 1;
  height: 60px;
  gap: 4px;
}

.btn-gradient {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.1));
  border: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.btn-gradient .icon-wrap {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #ff4b2b, #ff416c);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  box-shadow: 0 2px 8px rgba(255, 65, 108, 0.4);
}

.btn-text-large {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

.btn-white-trans {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7));
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.icon-red {
  color: #ff416c;
  font-size: 22px;
}

.btn-text-red {
  color: #ff416c;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
}

.icon-pink {
  color: #e1306c;
  font-size: 22px;
}

.btn-text-pink {
  color: #e1306c;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
}

.btn-dark-trans {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.icon-white {
  color: #fff;
  font-size: 22px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.icon-yellow {
  color: #f1c40f;
  font-size: 22px;
}

.btn-text-stack {
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: 1px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.btn-yellow {
  background: linear-gradient(135deg, #f1c40f, #f39c12);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(243, 156, 18, 0.3);
}

.btn-orange {
  background: linear-gradient(135deg, #e67e22, #d35400);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(211, 84, 0, 0.3);
}

.btn-text-white {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.pay-code-section {
  text-align: center;
  margin: 5px auto;
  width: 90%;
}

.pay-code-tip {
  color: #f53036;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 5px;
}

.pay-code-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #666;
  background: #fff;
  width: 100%;
}

.pay-code-text {
  flex: 1;
  padding: 6px 8px;
  font-size: 14px;
  color: #333;
}

.pay-code-copy {
  background: #4b4b52;
  color: #fff;
  padding: 8px 16px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.pay-action-btns {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: 5px auto 10px;
  gap: 10px;
}

.pay-action-btn {
  flex: 1;
  background: #4b4b52;
  color: #fff;
  text-align: center;
  padding: 8px 0;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}
</style>